import { computed } from 'vue'

import { formatVoiceDuration } from '../utils/voice-duration'

import type { UseVoiceRecorderBarLayoutOptions } from '../types/voice.types'

/** Layout + a11y derived state for VoiceRecorderBar chrome. */
export function useVoiceRecorderBarLayout(options: UseVoiceRecorderBarLayoutOptions) {
  const isPaused = computed(() => options.stage.value === 'paused')
  const isComposer = computed(() => options.variant.value === 'composer')
  const isCompact = computed(() => options.density.value === 'compact' && !isComposer.value)
  const controlSize = computed(() => (isCompact.value ? 'xs' : 'sm'))
  const controlIconClass = computed(() => (isCompact.value ? 'h-4 w-4' : 'h-5 w-5'))
  const waveformHeight = computed(() => (isCompact.value ? 18 : 28))
  const durationLabel = computed(() => formatVoiceDuration(options.elapsedMs.value / 1000))
  const pauseLabel = computed(() => (isPaused.value ? options.labels.value.resume : options.labels.value.pause))
  const confirmButtonId = computed(() => `${options.idPrefix.value}-${options.confirmAction.value}`)

  return {
    isPaused,
    isComposer,
    isCompact,
    controlSize,
    controlIconClass,
    waveformHeight,
    durationLabel,
    pauseLabel,
    confirmButtonId,
  }
}
